/*
 * 配置中心路由
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
export default {
  path: 'tenant',
  name: 'SettingTenant',
  component: EmptyRouterAlive,
  meta: {
    title: '租户',
  },
  children: [
    {
      path: 'manage',
      name: 'SettingTenantManage',
      redirect: 'manage/index',
      meta: {
        title: '租户管理',
      },
      component: EmptyRouter,
      children: [
        {
          path: 'index',
          name: 'SettingTenantManageIndex',
          component: () => import('@/views/center-setting/tenant/index'),
          meta: {
            title: '租户管理',
          },
        },
        {
          path: 'add',
          name: 'SettingTenantManageAdd',
          component: () => import('@/views/center-setting/tenant/add'),
          meta: {
            title: '添加租户',
          },
        },
        {
          path: 'edit',
          name: 'SettingTenantManageEdit',
          component: () => import('@/views/center-setting/tenant/edit'),
          meta: {
            title: '编辑管理',
          },
        },
        /** 按钮权限start */
        /** 按钮权限end */
      ],
    },
  ],
};
